<template>
  <full-page-modal
    :active="isShow"
    :needHeader="true"
    backgroundColor="#ffffff"
    closeButtonColor="#1253a4"
    @close="closeModal"
    titleInk="label"
    :title="title"
    :closeIconRight="true"
    class="filter-modal"
  >
    <q-spacer horizontal="xs" class="filter-modal__premi">
      <q-padder vertical="md" horizontal="xxs">
        <q-spacer bottom="xs">
          <q-text variant="ui-small" ink="label" bold>{{ content.QoalaOnlineHealthDetail.premiRangeLabel }}</q-text>
        </q-spacer>
        <q-input
          v-model="currencyPremi"
          variant="currency"
          :border="true"
          :additionField="true"
          :formalPadding="true"
          additionFieldValue="IDR"
          fontVariant="ui-small"
        />
        <q-spacer top="xs">
          <q-range-slider @input="getValue" :setValue="premi" :maxValue="maxPremi" />
          <q-spacer top="xs">
            <q-grid :column="2">
              <q-text variant="ui-small" ink="label" bold>IDR0</q-text>
              <q-text variant="ui-small" ink="label" bold right>IDR{{ $helper.currencies(maxPremi) }}</q-text>
            </q-grid>
          </q-spacer>
        </q-spacer>
      </q-padder>
    </q-spacer>
    <q-padder vertical="md" horizontal="sm" class="filter-modal__features">
      <q-text variant="ui-small" ink="label" bold>{{ content.QoalaOnlineHealthDetail.featureLabel }}</q-text>
      <q-spacer v-for="(feature, idx) in features" :key="idx" top="xxs">
        <q-checkbox :value="feature.value" @change.native="feature.value = !feature.value">
          {{ feature.label }}
        </q-checkbox>
      </q-spacer>
    </q-padder>
    <q-button class="filter-modal__button" @click="apply">{{
      content.QoalaOnlineHealthDetail.applyButtonLabel
    }}</q-button>
  </full-page-modal>
</template>

<script>
import {
  Padder as QPadder,
  Spacer as QSpacer,
  Text as QText,
  Grid as QGrid,
  Checkbox as QCheckbox,
  Button as QButton,
  Input as QInput,
  SelectBox as QSelectbox,
  FullPageModal,
  Card as QCard,
  Row,
  InputList
} from '@qoala/ui';
import { RangeSlider as QRangeSlider } from '@qoala/ui/v2';

export default {
  components: {
    QPadder,
    QSpacer,
    QText,
    QGrid,
    QCheckbox,
    QButton,
    QInput,
    Row,
    QSelectbox,
    InputList,
    QCard,
    QRangeSlider,
    FullPageModal
  },
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String
    },
    features: {
      type: Array
    },
    maxPremi: {
      type: Number,
      default: 0
    }
  },
  computed: {},
  data() {
    return {
      isShow: false,
      premi: 0,
      currencyPremi: '0'
    };
  },
  mounted() {},
  watch: {
    premi(e) {
      this.currencyPremi = this.$helper.currencies(e);
    },
    currencyPremi(e) {
      this.premi = Number(this.$helper.currenciesToNumber(e));
    }
  },
  methods: {
    showModal() {
      this.isShow = true;
    },
    closeModal() {
      this.isShow = false;
      this.$emit('closeModal', '');
    },
    apply() {
      this.$emit('handleFilter', this.premi);
      this.closeModal();
    },
    getValue(premi) {
      this.premi = premi;
    }
  }
};
</script>
<style lang="scss">
.filter-modal {
  &__premi {
    border-bottom: 1px solid rgba(148, 201, 222, 0.2);
    .currency {
      height: 35px;
      .addition-field {
        border-right: 0;
        width: 40px;
        padding-right: 0;
        .row-section {
          color: #1253a4;
          font-weight: bold;
          display: inline-block;
        }
      }
      input {
        color: #ff8742;
        font-weight: bold;
        padding-left: 4px;
      }
    }
    .eu-rangeslider-container {
      padding-right: 0;
    }
  }
  &__features {
    .checkbox-container {
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      color: #1253a4;
      margin-bottom: 4px;
      cursor: pointer;
      .checkbox {
        border: 0;
        background: #fffef2;
        border: 1px solid #ffa000;
        &.checked:before {
          background: linear-gradient(to bottom, #ff9738, #ff8743);
        }
      }
    }
  }
  &__button {
    border-radius: 8px !important;
    background-image: linear-gradient(to bottom, #ff9738, #ff8743);
    width: calc(100% - 24px) !important;
    position: fixed !important;
    bottom: 20px;
    left: 12px;
    right: 12px;
    @media screen and (max-width: 360px) {
      position: static !important;
      margin: 0 12px 24px 12px;
    }
  }
}
</style>
